import { getRoomById } from 'api/rooms.api';
import { $detail, $form, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import moment from 'moment';
import { getOrgFinancialMetrics } from 'api/metrics.api';
import { getOrgDocuments } from 'api/documents.api';
import mergeDocumentsAndFolders from 'utils/mergeFilesAndFolders';
import { getOrgFolders } from 'api/folders.api';
import { getOrgInvestors } from 'api/investors.api';

export async function fetchAndSetRoomData(id) {
  $view.update({
    isLoading: true,
  });
  try {
    const [metrics, { data: folders }, { data: documents }, { data: investors }, room] = await Promise.all([
      getOrgFinancialMetrics(),
      getOrgFolders(),
      getOrgDocuments(),
      getOrgInvestors(),
      getRoomById(id),
    ]);

    const mergedFolders = mergeDocumentsAndFolders(documents, folders);
    const investorOptions = investors?.map((investor) => ({
      label: investor.investorName,
      value: `${investor.recordType}-${investor.investorId}`,
      recordType: investor.recordType,
    }));

    $view.update({
      investorOptions,
      folders: mergedFolders,
      metrics,
      name: room.name,
    });

    $detail.update({ ...room });

    $form.update({
      ...room,
      fundingDate: moment(room.fundingDate).format('YYYY-MM-DD'),
      dataVaultInclusion: room.isIncludeAllDocuments ? 'all' : 'select',
    });
  } catch (error) {
    displayError({
      message: 'Failed to load room data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({
      isLoading: false,
    });
  }
}
